module.exports = __webpack_public_path__ + "fonts/169bc0f.eot";